import ConditionalLoader from '@Guidelines/Component/Loader/ConditionalLoader';
import { theme } from '@Guidelines/Theme/theme';
import { openAddFromDossierSheet } from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Preparations/Preparation/Signals/addFromDossierSheetSignal';
import { css } from '@emotion/react';
import * as React from 'react';
import { Button } from '@verclam/ui-kit';

const bannerStyle = css`
	display: flex;
	gap: 0.75rem;
	align-items: center;
	justify-content: space-between;
	flex-wrap: wrap;
	padding: 0.875rem 1rem;
	border-radius: ${theme.radii.medium};
	background-color: ${theme.states.warning.surface};
	color: ${theme.states.warning.solid};
	font-family: ${theme.fonts.body};
`;

const textStyle = css`
	display: flex;
	flex-direction: column;
	gap: 0.1875rem;
	flex: 1;
	min-width: 12rem;
`;

const titleStyle = css`
	font-size: 0.84375rem;
	font-weight: ${theme.fontWeights.semibold};
	line-height: 1.4;
`;

const detailStyle = css`
	font-size: 0.78125rem;
	line-height: 1.5;
`;

type Props = {
	readonly documentTypeId: number;
	readonly typeLabel: string;
	readonly verifiedOnly: boolean;
	/** Whether the visitor may choose the document by hand. */
	readonly canEdit: boolean;
};

/**
 * A document the group carries over automatically that the dossier does not hold: it is never filled in
 * silently, the professional picks it by hand — « Générer » stays blocked until then.
 */
const MissingSourceBanner: React.FC<Props> = ({ documentTypeId, typeLabel, verifiedOnly, canEdit }) => {
	const handleChooseClick = React.useCallback(() => {
		openAddFromDossierSheet({ replacesDocumentTypeId: documentTypeId });
	}, [documentTypeId]);

	return (
		<div css={bannerStyle} role="alert">
			<div css={textStyle}>
				<span css={titleStyle}>
					Aucun « {typeLabel} »{verifiedOnly ? ' vérifié' : ''} dans ce dossier
				</span>
				<span css={detailStyle}>
					Choisissez à la main le document à reprendre pour cette préparation.
				</span>
			</div>
			<ConditionalLoader data={canEdit}>
				<Button
					type="button"
					severity="secondary"
					label="Choisir à la main"
					onClick={handleChooseClick}
				/>
			</ConditionalLoader>
		</div>
	);
};

export default MissingSourceBanner;
